import { injectable } from 'inversify';
import React from 'react';

import { LogoutCardComponent } from '../ui/LogoutCard/LogoutCard.component';
import { TLogoutCard } from '../ui/LogoutCard/LogoutCard.view';

@injectable()
export class UserPrincipalComponentFactory {
  public createLogoutCardComponent(
    payload: TLogoutCard,
  ): React.ReactElement<TLogoutCard> {
    return LogoutCardComponent.create(payload);
  }
}
